import {LoaderCircle} from 'lucide-react';
import {uploadSizePair,uploadSpeed,type UploadProgress} from '../upload-progress';
import '../upload-progress.css';

export function UploadStatus({progress,destination}:{progress:UploadProgress|null;destination:string}) {
  const phase=progress?.phase??'checking';
  const label=phase==='checking'?'正在准备上传…':phase==='saving'?'正在保存…':`正在上传到${destination}…`;
  const percent=progress&&progress.totalBytes>0?Math.min(100,Math.floor(progress.uploadedBytes/progress.totalBytes*100)):0;
  const determinate=!!progress&&progress.determinate&&progress.totalBytes>0;
  return <div className="library-upload-progress">
    <div className="library-upload-heading" role="status"><LoaderCircle size={15} className="spin" aria-hidden="true"/><span>{label}</span>{progress&&progress.fileCount>1&&<span className="library-upload-count">{progress.fileIndex} / {progress.fileCount}</span>}</div>
    {progress&&<>
      <div className="library-upload-filename" title={progress.fileName}>{progress.fileName}</div>
      <div className="library-upload-metrics"><span>{uploadSizePair(progress.uploadedBytes,progress.totalBytes)}</span><span>{phase==='uploading'?uploadSpeed(progress.bytesPerSecond):phase==='saving'?'等待服务器确认':'检查可用空间'}</span></div>
      <progress className="library-upload-bar" aria-label="文件上传进度" aria-valuetext={`${uploadSizePair(progress.uploadedBytes,progress.totalBytes)}，${label}`} max={100} value={determinate?percent:undefined}/>
    </>}
  </div>;
}
